const blackListedTypes: any = {
  languageItem: true,
  education: true,
  experience: true,
};

export default function isAttributeBlackListed(attribute: any) {
  return !!blackListedTypes[attribute.type];
}
